import React from "react";
import { toElementProps } from "../../Element.js";
import useLoremIpsum from "../technical/useLoremIpsum.jsx";
import Feature, { FeatureStyles } from "./Feature.jsx";
import Grider, { GriderStyles } from "./Grider.jsx";

export function BlockFeaturesStyles(params = {}) {
    return {
        "& .block-features": {},

        ...GriderStyles(params),
        ...FeatureStyles(params),
    };
}

export default function BlockFeatures(props) {
    const { Features } = props.variables;
    const LI = useLoremIpsum();

    const _Features = Features || LI.Features;
    if (!Array.isArray(_Features)) {
        console.warn("Features is not array!");
        return null;
    }

    const variant = props.variant || 1;
    const elProps = toElementProps(props, { className: ["block-features", "inner-block", "override-feature-50"] });
    return (
        <div {...elProps}>
            <Grider mode="flex-wrap">
                {_Features?.map((feature, index) => (
                    <Feature key={index} {...feature} variant={variant} />
                ))}
            </Grider>
        </div>
    );
}
